import { animate, style, transition, trigger } from '@angular/animations';

export const enterLeaveAnimation = trigger('enterLeaveAnimation', [
  transition(':enter', [style({ opacity: 0 }), animate('160ms', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('500ms 300ms', style({ opacity: 0 }))]),
]);
